export const TEXT_FIELD_LIMITS = {
  shortCode: 20,
  uf: 2,
  cep: 10,
  phone: 20,
  document: 20,
  name: 120,
  title: 160,
  city: 120,
  neighborhood: 100,
  complement: 100,
  email: 254,
  address: 255,
  companyName: 255,
  url: 1000,
  bio: 255,
  description: 1000,
  skill: 50,
  idiomas: 250,
} as const;

export function maxLengthValidation(label: string, max: number) {
  return {
    value: max,
    message: `${label} deve ter no máximo ${max} caracteres`,
  };
}
